import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { SearchResultService } from './services/search-result-service';
import { SearchResultRepository } from './services/search-result-repository';
import { SearchResultApi } from './apis/search-result-api';
import { SearchResultServiceImpl } from './services/impls/search-result-service';
import { SearchResultRepositoryImpl } from './repositories/impls/search-result-repository';
import { SearchResultApiImpl } from './apis/impls/search-result-api';

export const searchResultContainer = new ContainerModule(bind => {
    bind(SearchResultService).to(SearchResultServiceImpl);
    bind(SearchResultRepository).to(SearchResultRepositoryImpl);
    bind(SearchResultApi).to(SearchResultApiImpl);
});
